<template>
  <div id="myChartPie3" :style="{ width: '100%', height: '270px' }"></div>
</template>

<script>
export default {
  props: ["tableDataPCopy1"],
  data() {
    return {
      tableDataPCopy: [],
    };
  },
  watch: {
    tableDataPCopy1(newvalue, oldvalue) {
      this.tableDataPCopy = newvalue;
      this.drawLinePie2()
    },
  },
  methods: {
    drawLinePie2() {
      let pieData = [];
      let pieDataArrP = Object.assign([], this.tableDataPCopy);
      pieDataArrP.pop();
      pieDataArrP.map((item) => {
        let obj = {};
        if (item.comName) {
          obj.name = item.comName;
          obj.value = (item.curAmount / 10000).toFixed(2);
        } else {
          obj.name = item.comDesc;
          obj.value = (item.yearAmount / 10000).toFixed(2);
        }
        pieData.push(obj);
      });
      let myChartPie3 = this.$echarts.init(
        document.getElementById("myChartPie3")
      );
      let option = {
        color: ["#2A8CF1", "#2DD18F", "#FFAC63", "#FF6363"],
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "horizontal",
          icon: "circle",
          bottom: "bottom",
          data: pieData,
          formatter: function (name) {
            let total = 0;
            let target;
            for (let i = 0, l = pieData.length; i < l; i++) {
              total += pieData[i].value;
              if (pieData[i].name == name) {
                target = pieData[i].value;
              }
            }
            if (name == "江苏分公司") {
              let arr = ["{a|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            } else if (name == "内蒙古分公司") {
              let arr = ["{b|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            } else {
              let arr = ["{c|" + target + "万" + "}", "{k|" + name + "}"];
              return arr.join("\n");
            }
          },
          textStyle: {
            rich: {
              k: {
                fontSize: 12,
                padding: [0, 0, 0, 0],
                lineHeight: 25,
                color: "#181818",
              },
              a: {
                color: "#2A8CF1",
                verticalAlign: "top",
                align: "center",
                fontSize: 14,
                padding: [0, 0, -0, 0],
              },
              b: {
                verticalAlign: "top",
                align: "center",
                fontSize: 14,
                padding: [0, 0, 0, 0],
                color: "#2DD18F",
              },
              c: {
                verticalAlign: "top",
                align: "center",
                fontSize: 14,
                padding: [0, 0, 0, 0],
                color: "#FFAC63",
              },
            },
          },
        },
        series: [
          {
            itemStyle: {
              normal: {
                label: {
                  show: true,
                  formatter: "{d}%",
                },
                labelLine: { show: true, length: 1 },
              },
            },

            type: "pie",
            radius: ["47%", "70%"],
            center: ["50%", "42%"],
            data: pieData,
            label: { show: false },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
      myChartPie3.setOption(option);
    },
  },
  mounted() {
    // setTimeout(() => {
    //   this.drawLinePie2();
    // }, 1000);
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/operationSummary/components/pieChartThree.vue